var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('liquidations-table',{attrs:{"items":_vm.liquidations,"loading":_vm.loading,"show-search":"","hide-payed-at":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }